<label class="switch">
  <input
    type="checkbox"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onValueChange($event)"
  />
  <span class="slider"></span>
</label>
<span class="switch-label" *ngIf="label">{{ label }}</span>
